import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitogoacabooking() {



    const cardData = {

keyword: "Mumbai to Goa Cab Booking",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Mumbai to Goa Cab Booking services for family vacations, group tours, honeymoon trips, corporate travel, weekend getaways, and one-way or round-trip journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup across Mumbai, and safe highway driving via the scenic Mumbai–Goa route, we ensure a smooth, comfortable, and hassle-free booking experience for every traveler.",

topPlaces: [
    {
        title: "Baga Beach",
        description:
            "Baga Beach is one of Goa’s most popular beaches, known for its vibrant nightlife, water sports, beach shacks, and energetic tourist atmosphere throughout the year."
    },
    {
        title: "Calangute Beach",
        description:
            "Calangute Beach is often called the Queen of Beaches and is famous for its long coastline, shopping stalls, water sports, and lively tourist crowd."
    },
    {
        title: "Anjuna Beach",
        description:
            "Anjuna Beach is known for its rocky shoreline, flea market, sunset views, and relaxed bohemian vibe attracting both domestic and international travelers."
    },
    {
        title: "Fort Aguada",
        description:
            "Fort Aguada is a well-preserved Portuguese fort overlooking the Arabian Sea, famous for its lighthouse, sea views, and historical significance from colonial times."
    },
    {
        title: "Dudhsagar Waterfalls",
        description:
            "Dudhsagar Waterfalls is one of India’s tallest waterfalls located on the Goa–Karnataka border, known for its milky white cascade and dense forest surroundings."
    },
    {
        title: "Basilica of Bom Jesus",
        description:
            "Basilica of Bom Jesus is a UNESCO World Heritage Site in Old Goa, famous for its baroque architecture and preserved relics of St. Francis Xavier."
    },
    {
        title: "Palolem Beach",
        description:
            "Palolem Beach in South Goa is known for its calm waters, scenic beauty, beach huts, and peaceful environment ideal for relaxing vacations."
    },
    {
        title: "Chapora Fort",
        description:
            "Chapora Fort offers stunning sunset views over Vagator Beach and is a popular photography and Bollywood filming location."
    },
    {
        title: "Candolim Beach",
        description:
            "Candolim Beach is a peaceful North Goa beach known for clean shores, water sports, and a relaxed environment away from heavy crowds."
    },
    {
        title: "Se Cathedral",
        description:
            "Se Cathedral is one of the largest churches in Asia, admired for its Portuguese-Gothic architecture and deep historical importance in Old Goa."
    }
],



services: [
{
name: "Mumbai to Goa Cab Booking Price",
description: "Mumbai to Goa Cab Booking Price service by 1Touch Cabs provides transparent and competitive pricing for all types of vehicles including Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, and Luxury Cars. We ensure fair pricing with no hidden charges, offering affordable and reliable long-distance travel for families, tourists, and corporate travelers.",
},
{
name: "Mumbai to Goa Cab Charges",
description: "Mumbai to Goa Cab Charges service offers clear and upfront fare details for one-way and round-trip journeys. 1Touch Cabs provides economical pricing based on vehicle type, travel distance, and trip requirements while ensuring comfort and safety throughout the journey.",
},
{
name: "Mumbai to Goa Cab Rates",
description: "Mumbai to Goa Cab Rates service ensures budget-friendly and transparent pricing for all categories of travelers. We offer flexible rate options for Sedan, SUV, Innova, and premium vehicles with 24x7 booking support and reliable service.",
},
{
name: "Mumbai to Goa Cab Service Fare",
description: "Mumbai to Goa Cab Service Fare provides clear and affordable pricing for long-distance travel between Mumbai and Goa. 1Touch Cabs ensures no hidden charges and offers competitive fares for all vehicle types.",
},
{
name: "Mumbai to Goa Car Hire",
description: "Mumbai to Goa Car Hire service offers flexible transportation options for one-way, round-trip, and holiday travel. We provide well-maintained vehicles with professional chauffeurs for a safe and comfortable journey.",
},
{
name: "Mumbai to Goa Car Booking",
description: "Mumbai to Goa Car Booking service allows quick and easy online reservations with instant confirmation. 1Touch Cabs provides multiple vehicle choices, transparent pricing, and reliable customer support.",
},
{
name: "Mumbai to Goa One Way Cab",
description: "Mumbai to Goa One Way Cab service provides cost-effective travel without return fare charges. Ideal for tourists, families, and solo travelers looking for affordable long-distance transportation.",
},
{
name: "Mumbai to Goa Taxi Price",
description: "Mumbai to Goa Taxi Price service offers affordable and competitive pricing for intercity travel with professional drivers and clean AC vehicles ensuring a smooth journey.",
},
{
name: "Mumbai to Goa Taxi Rate",
description: "Mumbai to Goa Taxi Rate service ensures transparent fare structure based on vehicle type and travel needs, offering budget to premium options for all travelers.",
},
{
name: "Mumbai to Goa One Way Taxi",
description: "Mumbai to Goa One Way Taxi service provides convenient and affordable single-trip transportation with experienced chauffeurs and comfortable vehicles.",
},
{
name: "Taxi Service from Mumbai to Goa",
description: "Taxi Service from Mumbai to Goa offers reliable long-distance transportation with professional drivers, door-to-door pickup, and 24x7 availability for a safe travel experience.",
},
{
name: "Mumbai to Goa Taxi Service",
description: "Mumbai to Goa Taxi Service ensures safe, comfortable, and punctual travel with well-maintained vehicles and experienced chauffeurs for families, tourists, and business travelers.",
},
{
name: "Luxury Cab Mumbai to Goa",
description: "Luxury Cab Mumbai to Goa service provides premium vehicles with high-end interiors, professional chauffeurs, and superior comfort for VIP and executive travel.",
},
{
name: "Best Mumbai to Goa Cab Service",
description: "Best Mumbai to Goa Cab Service offers reliable, safe, and affordable long-distance travel with multiple vehicle options and excellent customer support.",
},
{
name: "Online Mumbai to Goa Cab Booking",
description: "Online Mumbai to Goa Cab Booking allows instant reservations with transparent pricing, multiple vehicle choices, and 24x7 customer assistance.",
},
{
name: "Mumbai to Goa Chauffeur Driven Cab",
description: "Mumbai to Goa Chauffeur Driven Cab service provides professional driver assistance for a stress-free and comfortable long-distance journey.",
},
{
name: "Mumbai to Goa Kia Carens Cab",
description: "Mumbai to Goa Kia Carens Cab service offers spacious seating, modern comfort, and smooth ride quality ideal for family and group travel.",
},
{
name: "Mumbai to Goa Airport Drop Cab",
description: "Mumbai to Goa Airport Drop Cab service provides reliable transportation from Mumbai to Goa airport destinations with punctual pickup and safe travel.",
},
{
name: "Mumbai to Goa Holiday Cab Package",
description: "Mumbai to Goa Holiday Cab Package offers complete travel solutions for vacations, including sightseeing support, comfortable vehicles, and flexible trip planning.",
},
{
name: "Mumbai to Goa Tour Package by Cab",
description: "Mumbai to Goa Tour Package by Cab service provides customized travel itineraries with professional chauffeurs, ensuring a comfortable and enjoyable Goa trip."
}
],

tableData: [
["Mumbai to Goa Cab Booking Price","Mumbai to Goa Cab Charges"],
["Mumbai to Goa Cab Rates","Mumbai to Goa Cab Service Fare"],
["Mumbai to Goa Car Hire","Mumbai to Goa Car Booking"],
["Mumbai to Goa One Way Cab","Mumbai to Goa Taxi Price"],
["Mumbai to Goa Taxi Rate","Mumbai to Goa One Way Taxi"],
["Taxi Service from Mumbai to Goa","Mumbai to Goa Taxi Service"],
["Luxury Cab Mumbai to Goa","Best Mumbai to Goa Cab Service"],
["Online Mumbai to Goa Cab Booking","Mumbai to Goa Chauffeur Driven Cab"],
["Mumbai to Goa Kia Carens Cab","Mumbai to Goa Airport Drop Cab"],
["Mumbai to Goa Holiday Cab Package","Mumbai to Goa Tour Package by Cab"]
],



















whychoose: [
    {
        WhyChooseheading: "Reliable Mumbai to Goa Cab Booking Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mumbai to Goa Cab Booking services for families, couples, tourists, corporate travelers, and vacationers seeking comfortable long-distance transportation."
    },
    {
        WhyChooseheading: "Easy and Hassle-Free Cab Reservations",
        WhyChoosedescription: "Book your Mumbai to Goa cab quickly through phone, WhatsApp, or online inquiry and enjoy a smooth travel experience with instant booking assistance."
    },
    {
        WhyChooseheading: "Perfect for Holidays, Vacations, and Road Trips",
        WhyChoosedescription: "Whether you are planning a beach holiday, honeymoon, family vacation, friends' trip, or corporate outing, our cab services offer comfortable travel solutions."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Choose from Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and luggage requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Cab Booking",
        WhyChoosedescription: "Customers can choose one-way transfers, round trips, weekend packages, holiday tours, and customized Goa travel itineraries."
    },
    {
        WhyChooseheading: "Doorstep Pickup Across Mumbai",
        WhyChoosedescription: "Pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Dombivli, Kalyan, Andheri, Borivali, Bandra, Dadar, Powai, and nearby locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Goa Routes",
        WhyChoosedescription: "Our professional chauffeurs are experienced on Mumbai-Goa highway routes and ensure safe, comfortable, and stress-free transportation throughout the journey."
    },
    {
        WhyChooseheading: "Ideal for Families, Couples, and Tourist Groups",
        WhyChoosedescription: "From honeymoon couples and family vacationers to corporate teams and large tourist groups, we provide suitable vehicles for every Goa travel requirement."
    }
]
};

const faqData = [
    {
        question: "How can I book a Mumbai to Goa Cab?",
        answer: "Customers can book a cab through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    },
    {
        question: "Can I book a one-way cab from Mumbai to Goa?",
        answer: "Yes, one-way cab booking services are available along with round-trip and customized Goa holiday packages."
    },
    {
        question: "Which vehicle is suitable for Mumbai to Goa travel?",
        answer: "Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and Mini Buses are available according to passenger count and travel preferences."
    },
    {
        question: "Can families book cabs for Goa vacations?",
        answer: "Yes, many families choose our cab services for comfortable travel to Goa resorts, hotels, villas, beaches, and sightseeing destinations."
    },
    {
        question: "Are Tempo Travellers available for Goa group tours?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, corporate outings, bachelor trips, and tourist groups."
    },
    {
        question: "Can I get pickup from Mumbai Airport?",
        answer: "Yes, pickup services are available from Mumbai Airport, hotels, railway stations, offices, and residential locations."
    },
    {
        question: "Can sightseeing stops be included during the trip?",
        answer: "Yes, customers can customize their itinerary and include Konkan sightseeing points, beaches, waterfalls, forts, restaurants, and tourist attractions."
    },
    {
        question: "Do you provide hotel and resort drop services in Goa?",
        answer: "Yes, doorstep drop services are available at hotels, resorts, villas, beaches, and tourist destinations across North and South Goa."
    },
    {
        question: "Is advance booking recommended for Mumbai to Goa travel?",
        answer: "Yes, advance booking is highly recommended during weekends, long holidays, Christmas, New Year, and peak tourist seasons."
    },
    {
        question: "Can I book a round-trip cab from Mumbai to Goa?",
        answer: "Yes, customers can choose round-trip cab bookings with flexible return schedules and customized travel plans."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Kunal Patwardhan",
        feedback:
            "The Mumbai to Goa cab booking process was very simple and quick. The vehicle was comfortable, the driver was professional, and the journey was enjoyable from start to finish.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Richa Desai",
        feedback:
            "We booked a Goa vacation cab for our family and had an excellent experience. The cab arrived on time, was very clean, and the service was outstanding throughout the trip.",
        rating: 5
    }
];


















   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Goa Cab Booking Service",
  "image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-goa-cab-booking.jpg",
  "description": "Book Mumbai to Goa cab service for safe, comfortable, and affordable outstation travel. Mumbai Airport Cabs offers reliable taxi booking with transparent pricing, professional drivers, and 24x7 availability for one-way and round trips.",
  "brand": {
    "@type": "Brand",
    "name": "Mumbai Airport Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "10800"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹10,999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.mumbaiairportcabs.com/mumbai-to-goa-cab-booking"
  }
};




    return (
        <div>


<Helmet>
  <title>Mumbai to Goa Cab Booking | Affordable Taxi Service | +91 9545731161</title>

  <meta
    name="description"
    content="Book Mumbai to Goa cab service at best prices. Transparent fare, reliable drivers, and 24x7 taxi booking for one-way and round trips."
  />

  <meta
    name="keywords"
    content="Mumbai to Goa cab booking price, Mumbai to Goa cab charges, Mumbai to Goa cab rates, Mumbai to Goa cab service, Mumbai to Goa car hire, Mumbai to Goa one way cab, Mumbai to Goa taxi price, Mumbai to Goa taxi rate, Mumbai to Goa one way taxi, taxi service from Mumbai to Goa"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>









            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/4.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitogoacabooking;